// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"663b1dd7","252":"fe6c9549","283":"5153356b","453":"16ad4935","499":"09a0f72e","734":"35f7ff49","873":"731bc160","895":"72afdd5a","937":"50b4159f"}[chunkId] + ".chunk.js";
};